import React from 'react'
import CanadaTemplateDefault from 'src/components/template/ca/'
import { leagueIds, sportIds } from 'src/constants/personalizationIds'
import { canadaPlanSet, canadaSports_EPL_UCL_Override } from 'src/constants/planData/canadaPlanData'
import { useCohortFlag } from 'src/modules/hooks/useCohortFlag'
import { useEPLImage } from 'src/modules/hooks/useEPLImage'
import { WEB_MARKETING_CA_VALUE_PROPS } from 'src/modules/reducers/cohorts/constants'
import { subtitleText } from 'src/modules/utils/constants'

export default (props) => {
  const posterImg = useEPLImage()
  const showValueProps = useCohortFlag(WEB_MARKETING_CA_VALUE_PROPS)
  const valuePropsCopy = ['Unlimited Cloud DVR', 'Cancel Anytime', 'Every EPL Match']
  return (
    <CanadaTemplateDefault
      location={props.location}
      lang="en"
      market="canada"
      // video={videos.canada_epl.videoUrl}
      // Static Image
      poster={posterImg}
      noVideo={true}
      title="Watch Premier League All Season"
      subtitle={subtitleText.epl}
      networkSet="canada_sports"
      logo="https://assets-imgx.fubo.tv/marketing/lp/images/partners/logo-lockup-epl-white.png?ch=width&auto=format,compress"
      logoHeight="90px"
      matchtickerSportId={sportIds.Soccer}
      matchtickerLeagueName="Premier League"
      matchtickerLeagueId={leagueIds['Premier League']}
      sportId={sportIds.Soccer}
      leagueId={leagueIds['Premier League']}
      planCardsConfig={{
        plans: canadaPlanSet.sports,
        overrides: canadaSports_EPL_UCL_Override,
      }}
      valuePropsCopy={showValueProps ? valuePropsCopy : null}
    />
  )
}
